import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import ReactDOM from 'react-dom/client';
import { SENTRY_DSN } from 'shared/constants';
import Root from './Root';
import * as serviceWorker from './serviceWorker';

const rootEl = document.getElementById('root') as Element;

if (['production', 'staging', 'development', 'local'].includes(process.env.REACT_APP_ENVIRONMENT as string)) {
	// Create a reusable render method that we can call more than once
	Sentry.init({
		dsn: SENTRY_DSN,
		integrations: [new BrowserTracing()],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0,
		sendDefaultPii: true,
		beforeSend(event) {
			if (typeof window !== 'undefined') {
				const url = new URL(window.location.href);

				// Define a plain object to hold filtered params
				const cleanParams: Record<string, string> = {};
				const sensitiveKeys = ['token', 'auth', 'password', 'access_token'];

				// Loop through params and copy safe ones
				for (const [key, value] of url.searchParams.entries()) {
					if (!sensitiveKeys.includes(key.toLowerCase())) {
						cleanParams[key] = value;
					}
				}

				event.tags = {
					...(event.tags || {}),
					page_url: window.location.href.split('?')[0] // Remove query params from page_url
				};

				event.extra = {
					...(event.extra || {}),
					queryParams: cleanParams
				};
			}
			return event;
		}
	});
}

const root = ReactDOM.createRoot(rootEl);
// Wrap your component in StrictMode to activate additional checks and warnings
root.render(<Root />);

serviceWorker.unregister();
